import React from "react";
import { SectionHeader } from "../common/section-header.component";

export const NewsPageHeader: React.FC = () => {
  return (
    <SectionHeader 
      titleKey="INVOZIO_NEWS_TITLE" 
      subtitleKey="INVOZIO_NEWS_SUBTITLE"
      className="invozio-news-section"
      titleClassName="main-title"
      subtitleClassName="sub-title"
    />
  );
};

export default NewsPageHeader;
